import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import * as actions from "../../actions/sysConfigActions";
import * as streamActions from "../../actions/streamListActions";
import Card from "../../components/Card/Card.jsx";
import "../../assets/css/sysconfig-page.css";
import { Grid, Row, Col, Panel, Form, ControlLabel, Modal, FormGroup, FormControl } from "react-bootstrap";

import HorizontalFormInputs from "../../components/FormInputs/HorizontalFormInputs.jsx";
import HorizontalFormFileUpload from "../../components/FormInputs/HorizontalFormFileUpload.jsx";
import Progress from "../../components/Progress/Progress.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";
import Checkbox from "../../components/CustomCheckbox/CustomCheckbox.jsx";
import Radio from "../../components/FormInputs/HorizontalFormRadiobuttons.jsx";
import { KeyValueDropdown } from "../../components/Dropdown/KeyValueDropdown";
import Switch from 'react-bootstrap-switch';

class SysConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nics: Object.assign({}, props.nics),
      about: Object.assign({}, props.about),
      password: "",
      newPassword: "",
      confirmPassword: "",
      passwordError: null,
      passwordConfirmError: null,
      importexport: Object.assign({optionImportExport: "export", sourceFile: null}, props.importexport),
      backupFiles: [],
      uploadFile: '',
      uploadFileName: '',
      uploadFileUpdate: '',
      uploadFileNameUpdate: '',
      enableSSH: props.enableSSH,
      showFileUpload: false,
      showAuthModal: false,
      showUpdateModal: props.showUpdateModal,
      showProgress: false,
      disableUpload: false,
      uploadPercentage: 0,
      serverAction: false,
      authError: false,
      updateError: false
    };
    this.updateState = this.updateState.bind(this);
    this.onSave = this.onSave.bind(this);
    this.downloadContainersBackup = this.downloadContainersBackup.bind(this);
    this.clearContainersBackup = this.clearContainersBackup.bind(this);
    this.onUploadSelected = this.onUploadSelected.bind(this);
    this.onUpload = this.onUpload.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.onPasswordReset = this.onPasswordReset.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
    this.handleImportStreams = this.handleImportStreams.bind(this);
    this.handleExportStreams = this.handleExportStreams.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.openAuthModal = this.openAuthModal.bind(this);
    this.closeAuthModal = this.closeAuthModal.bind(this);
    this.closeUpdateModal = this.closeUpdateModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.handleServerAction = this.handleServerAction.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.nics !== nextProps.nics)
      this.setState({ nics: nextProps.nics });
    if (this.props.about !== nextProps.about)
      this.setState({ about: nextProps.about });
    if (this.props.showUpdateModal !== nextProps.showUpdateModal)
      this.setState({ showUpdateModal: nextProps.showUpdateModal });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  onKeyPress(e){
    if(e.key === 'Enter')
      e.preventDefault();
  }

  handleImportStreams(e) {
    e.preventDefault();
    this.props.streamActions
      .importStreams(this.state.importexport.sourceFile, window.location.origin);
  }

  handleExportStreams(e) {
    e.preventDefault();
    this.props.streamActions
      .exportStreams(window.location.origin);
  }

  backupFileNameFormatter = (value) => {
    return new moment(value).format("MM/DD/YYYY hh:mm:ss.SSS A");
  };

  updateState = (value, label, eth) => {
    const nics = JSON.parse(JSON.stringify(this.state.nics)); //deep clone so we don't mutate state
    const importexport = JSON.parse(JSON.stringify(this.state.importexport));
    if (label === "isManagement") {
      nics.eth.map(nic => {
        if (nic[eth]) nic[eth].isManagement = true;
        else {
          nic[Object.keys(nic)].isManagement = false;
        }
      });
    } else if (label === "managementPort") {
      nics.managementPort = value;
    } else if (label === "optionImportExport") {
      if(value === 'import') {
        this.props.streamActions.getBackups(window.location.origin);
      }
      importexport.optionImportExport = value;
      this.setState({ importexport: importexport });
    } else if (label === "sourceFile") {
      importexport.sourceFile = value;
      this.setState({ importexport: importexport });
    } else if (label === "fileUpload") {
      this.setState({ uploadFile: value[0], uploadFileName: value[0].name });
    } else if (label === "updateFileUpload") {
      this.setState({ uploadFileUpdate: value[0], uploadFileNameUpdate: value[0].name });
    } else {
      let currentNic = nics.eth.filter(nic => {
        if (nic[eth]) {
          nic[eth][label] = value;
          return nic[eth];
        } else {
          return nic;
        }
      });
      nics.eth = currentNic;
    }
    this.setState({ nics: nics });

    var re = /^((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(?![\d])$/;
    var errorField = eth + "Error";
    re.test(value) === false
      ? this.setState({
          destIPError: (
            <small className="text-danger" style={{ marginLeft: 200 + "px" }}>
              Please enter valid IP Address such as: <i>127.0.0.1</i>.
            </small>
          )
        })
      : this.setState({ destIPError: false });
  };

  handlePasswordChange(value,label) {
    if(label === 'password')
    this.setState({
      password: value
    });
    else{
        this.setState({
          newPassword: value
        });
    value.length < 4
      ? this.setState({
          passwordError: (
          <small className="text-danger" style={{marginLeft: 155 + "px"}}>
              You must enter a password of at least 4 characters.
            </small>
          )
        })
      : this.setState({ passwordError: null });
      }
  }

  handleConfirmPasswordChange(value) {
    this.setState({
      confirmPassword: value
    });
      value !== this.state.newPassword
      ? this.setState({
          passwordConfirmError: (
          <small className="text-danger" style={{marginLeft: 155 + "px"}}>Passwords do not match.</small>
          )
        })
      : this.setState({ passwordConfirmError: null });
  }

  onSave = event => {
    event.preventDefault();
    this.props.actions.saveNetworkSettings(this.state.nics, window.location.origin);
  };

  downloadContainersBackup = event => {
    event.preventDefault();
    this.props.actions.downloadContainersBackup(window.location.origin);
  };

  clearContainersBackup = event => {
    event.preventDefault();
    this.props.actions.clearContainersBackup(window.location.origin);
  };

  onUploadSelected = event => {
    event.preventDefault();
    this.setState({ showFileUpload: true });
  };

  onUpload = event => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('file', this.state.uploadFile);
    this.props.actions.uploadFile(formData, window.location.origin);
  };

  onCancel = event => {
    event.preventDefault();
    this.setState({ showFileUpload: false });
  };

  onUpdate = event => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('file', this.state.uploadFileUpdate);
    this.setState({ showProgress: true, disableUpload: true });
    this.props.actions.uploadUpdateFile(formData, window.location.origin, (progressEvent) => {
      let percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      this.setState({ uploadPercentage:  percent});
      if(percent >= 100) {
        setTimeout(() => {
          this.setState({ showProgress: false });
        }, 1000);
        setTimeout(() => {
          this.setState({ showUpdateModal: false, disableUpload: false });
        }, 2000);
      }
    });
  };

  onPasswordReset = event => {
    event.preventDefault();
    var newPasswordObj = {};
    newPasswordObj.password = this.state.password;
    newPasswordObj.newPassword = this.state.newPassword;
    this.props.actions.resetPassword(newPasswordObj, window.location.origin)
      .then(() => this.setState({
        password: '',
        newPassword: '',
        confirmPassword: ''
      }))
  }

  handleSwitch(elem, state) {
    if (elem.props.statekey === "enableSSH") {
      var enableSSHObj = {};
      enableSSHObj.enableSSH = state;
      this.props.actions.saveSSHSettings(enableSSHObj, window.location.origin);
      this.setState({ enableSSH: state });
    }
  }

  openAuthModal(e, action) {
    e.preventDefault();
    this.setState({ showAuthModal: true, serverAction: action });
  }

  closeAuthModal(){
    this.setState({ showAuthModal: false });
  }

  closeUpdateModal() {
    this.setState({ showUpdateModal: false });
    this.props.actions.updateProps({showUpdateModal: false});
  }

  handleServerAction(e) {
    e.preventDefault();
    var data = {};
    data.password = this.state.password;
    data.action = this.state.serverAction;
    setTimeout(() => {
      this.setState({ showAuthModal: false });
    }, 500);
    this.props.actions.execServerAction(data, window.location.origin)
    .then((result, err) => {
    if (result){
      console.log('Success!');
    } else if(err) {
      console.log('Incorrect login!');
    }
    })
    .catch( () =>{
      console.log('Incorrect login!');
    })
  }

  render() {
    // let ddlVals = this.state.nics.eth.map(eth => Object.keys(eth)[0]);
    return (
      <div className="content">
        <Grid fluid>
          <Panel bsStyle="primary">
            <Panel.Heading>
              <Panel.Title componentClass="h3">
                System Configuration
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <Row md={12}>
                <Col
                  md={6}
                  style={{ paddingLeft: 3 + "px", paddingRight: 3 + "px" }}
                >
                  <Card
                    title="Network settings"
                    content={
                      <Form horizontal style={{ paddingTop: 33 + "px" }}>
                        {this.state.nics.eth.map((nic, index) => {
                          let key = Object.keys(nic)[0];
                          return (
                            <Panel key={index}>
                              <Panel.Body>
                                <Row className="show-grid">
                                  <Col md={6}>
                                    <HorizontalFormInputs
                                      ncols={["col-md-12"]}
                                      label="Adapter"
                                      type="text"
                                      bsClass="form-control"
                                      key={index}
                                      value={key}
                                      disabled={true}
                                    />
                                  </Col>

                                  <Col md={6}>
                                    <HorizontalFormInputs
                                      ncols={["col-md-12"]}
                                      onValueChange={this.updateState}
                                      statekey="address"
                                      eth={key}
                                      label="IP"
                                      type="text"
                                      key={index}
                                      bsClass="form-control"
                                      value={nic[key].address}
                                    />
                                  </Col>
                                </Row>
                                <Row className="show-grid">
                                  <Col md={6}>
                                    <HorizontalFormInputs
                                      ncols={["col-md-12"]}
                                      onValueChange={this.updateState}
                                      statekey="gateway"
                                      eth={key}
                                      label="Gateway"
                                      type="text"
                                      bsClass="form-control"
                                      key={index}
                                      value={nic[key].gateway}
                                      required="true"
                                      pattern="^([0-9]{1,3}.){3}[0-9]{1,3}$"
                                    />
                                  </Col>
                                  <Col md={6}>
                                    <HorizontalFormInputs
                                      ncols={["col-md-12"]}
                                      onValueChange={this.updateState}
                                      statekey="netmask"
                                      eth={key}
                                      label="Mask"
                                      type="text"
                                      bsClass="form-control"
                                      value={nic[key].netmask}
                                      key={index}
                                      required={true}
                                      pattern="^([0-9]{1,3}.){3}[0-9]{1,3}$"
                                    />
                                  </Col>
                                </Row>
                                {/* <Row className="show-grid">
                                  <Col md={12}>
                                    <Checkbox
                                      number={`cb` + key}
                                      checked={nic[key].isManagement}
                                      eth={key}
                                      key={index}
                                      label="Management"
                                      statekey="isManagement"
                                      onValueChange={this.updateState}
                                      inline={true}
                                    />
                                  </Col>
                                </Row> */}
                              </Panel.Body>
                            </Panel>
                          );
                        })}

                        <Col md={8}>
                          <HorizontalFormInputs
                            ncols={["col-md-12"]}
                            label="Management Port"
                            value={this.state.nics.managementPort}
                            onValueChange={this.updateState}
                            statekey="managementPort"
                            type="text"
                            bsClass="form-control"
                            required={true}
                            disabled={false}
                          />
                        </Col>
                        <Col md={7} xs={7} style={{ marginTop: 20 + "px" }}>
                          <Button
                            bsStyle="info"
                            pullRight
                            fill
                            type="submit"
                            onClick={e => this.onSave(e)}
                          >
                            Save
                          </Button>
                        </Col>
                        <div className="clearfix" />
                      </Form>
                    }
                  />

                  <Card
                    title="Import/Export Stream List"
                    content={
                      <Form horizontal style={{ paddingTop: 33 + "px" }}>
                        <Panel>
                          <Panel.Body>
                            <Row className="show-grid text-center" style={{display: (this.state.showFileUpload ?'none':'block' )}}>
                              <Radio
                                ncols={["col-md-4"]}
                                label="Import"
                                name="import-export-option"
                                value="import"
                                statekey="optionImportExport"
                                onValueChange={this.updateState}
                                checked={this.state.importexport.optionImportExport === "import"}
                                required={true}
                                disabled={false}
                              />
                              <Radio
                                ncols={["col-md-4"]}
                                label="Export"
                                name="import-export-option"
                                value="export"
                                statekey="optionImportExport"
                                onValueChange={this.updateState}
                                checked={this.state.importexport.optionImportExport === "export"}
                                required={true}
                                disabled={false}
                              />
                              <Radio
                                ncols={["col-md-4"]}
                                label="Manage"
                                name="import-export-option"
                                value="manage"
                                statekey="optionImportExport"
                                onValueChange={this.updateState}
                                checked={this.state.importexport.optionImportExport === "manage"}
                                required={true}
                                disabled={false}
                              />
                            </Row>
                            <Row className="show-grid files-list" style={{display: (this.state.importexport.optionImportExport === "import"?'block':'none' )}}>
                              <Col md={8} style={{ textAlign: "center" }}>
                                <KeyValueDropdown
                                  ncols={["col-md-12"]}
                                  onValueChange={this.updateState}
                                  formatter={this.backupFileNameFormatter}
                                  statekey="sourceFile"
                                  title={"Select File"}
                                  proprieties={[
                                    {
                                      label: "File",
                                      type: "text",
                                      bsClass: "form-control",
                                      placeholder: "Select File",
                                      children: this.props.backupFiles
                                    }
                                  ]}
                                />
                              </Col>
                            </Row>
                            <Row className="show-grid" style={{display: (this.state.importexport.optionImportExport === "import"?'block':'none' )}}>
                              <Col md={12} style={{ textAlign: "center" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  onClick={e => this.handleImportStreams(e)}
                                >Import</Button>
                              </Col>
                            </Row>
                            <Row className="show-grid" style={{display: (this.state.importexport.optionImportExport === "export"?'block':'none' )}}>
                              <Col md={12} style={{ textAlign: "center", marginTop: "10px" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  onClick={e => this.handleExportStreams(e)}
                                >Export</Button>
                              </Col>
                            </Row>
                            <Row className="show-grid" style={{display: (this.state.importexport.optionImportExport === "manage" && !this.state.showFileUpload?'block':'none' )}}>
                              <Col md={4} style={{ textAlign: "center", marginTop: "10px" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  onClick={e => this.downloadContainersBackup(e)}
                                >Download</Button>
                              </Col>
                              <Col md={4} style={{ textAlign: "center", marginTop: "10px" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  onClick={e => this.onUploadSelected(e)}
                                >Upload</Button>
                              </Col>
                              <Col md={4} style={{ textAlign: "center", marginTop: "10px" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  onClick={e => this.clearContainersBackup(e)}
                                >Clear All</Button>
                              </Col>
                            </Row>
                            <Row className="show-grid" style={{display: (this.state.importexport.optionImportExport === "manage" && this.state.showFileUpload?'block':'none' )}}>
                              <Col md={12} style={{ textAlign: "center" }}>
                                <HorizontalFormFileUpload
                                  ncols={["col-md-12"]}
                                  label="File"
                                  onValueChange={this.updateState}
                                  statekey="fileUpload"
                                  type="file"
                                  bsClass="form-control"
                                  required={true}
                                  disabled={false}
                                />
                              </Col>
                            </Row>
                            <Row className="show-grid" style={{display: (this.state.importexport.optionImportExport === "manage" && this.state.showFileUpload?'block':'none' )}}>
                              <Col md={3} />
                              <Col md={3} style={{ textAlign: "center" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  onClick={e => this.onUpload(e)}
                                >Upload</Button>
                              </Col>
                              <Col md={3} style={{ textAlign: "center" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  onClick={e => this.onCancel(e)}
                                >Cancel</Button>
                              </Col>
                              <Col md={3} />
                            </Row>
                          </Panel.Body>
                        </Panel>

                        
                        <div className="clearfix" />
                      </Form>
                    }
                  />
                </Col>
                <Col
                  md={6}
                  style={{ paddingLeft: 3 + "px", paddingRight: 3 + "px" }}
                >
                  <Card
                    title="About"
                    content={
                      <Form horizontal style={{ paddingTop: 33 + "px" }}>
                        <HorizontalFormInputs
                          ncols={["col-md-8"]}
                          label="Licenses: "
                          type="text"
                          bsClass="form-control"
                          value={this.state.about.licenses}
                          disabled={true}
                        />

                        <HorizontalFormInputs
                          ncols={["col-md-8"]}
                          label="Version:"
                          type="text"
                          bsClass="form-control"
                          value={this.state.about.appVersion}
                          disabled={true}
                        />

                        <div className="clearfix" />
                      </Form>
                    }
                  />
                  <Card
                    title="Password Reset"
                    content={
                      <Form horizontal style={{ paddingTop: 33 + "px" }}>
                        <HorizontalFormInputs
                          ncols={["col-md-8"]}
                          label="Current Password: "
                          type="password"
                          bsClass="form-control"
                          statekey="password"
                          value={this.state.password}
                          disabled={false}
                          onValueChange={this.handlePasswordChange}
                          name="current-password"
                        />

                        <HorizontalFormInputs
                          ncols={["col-md-8"]}
                          label="New Password:"
                          type="password"
                          bsClass="form-control"
                          statekey="newPassword"
                          value={this.state.newPassword}
                          disabled={false}
                          onValueChange={this.handlePasswordChange}
                          name="new-password"
                        />
                        {this.state.passwordError}
                        <HorizontalFormInputs
                          ncols={["col-md-8"]}
                          label="Confirm Password:"
                          type="password"
                          bsClass="form-control"
                          disabled={false}
                          onValueChange={this.handleConfirmPasswordChange}
                          value={this.state.confirmPassword}
                        />
                        {this.state.passwordConfirmError}
                        <Col md={7} xs={7} style={{ marginTop: 20 + "px" }}>
                          <Button
                            bsStyle="info"
                            pullRight
                            fill
                            type="submit"
                            onClick={e => this.onPasswordReset(e)}
                          >
                            Save
                          </Button>
                          </Col>
                        <div className="clearfix" />
                      </Form>
                    }
                  />
                  <Card
                    title="Server settings"
                    content={
                      <Form horizontal style={{ paddingTop: 33 + "px" }}>
                        <Panel>
                          <Panel.Body>
                            <Row className="show-grid files-list">
                              <Col componentClass={ControlLabel} xs={6} style={{ textAlign: "right", paddingTop: "3px" }}>
                                SSH:
                              </Col>
                              <Col xs={6}>
                                <Switch onChange={(el, state) => this.handleSwitch(el, state)} bsSize="mini" statekey="enableSSH" name='enableSSH' value={this.props.enableSSH} defaultValue={this.props.enableSSH} />
                              </Col>
                            </Row>
                            <Row className="show-grid files-list" style={{ marginTop: 20 + "px" }}>
                              <Col md={6} style={{ textAlign: "center", marginTop: "10px" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  style={{width: "135px"}}
                                  onClick={e => this.openAuthModal(e, 'poweroff')}
                                >Shutdown</Button>
                              </Col>
                              <Col md={6} style={{ textAlign: "center", marginTop: "10px" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  style={{width: "135px"}}
                                  onClick={e => this.openAuthModal(e, 'reboot')}
                                >Reboot</Button>
                              </Col>
                            </Row>
                            <Row className="show-grid files-list">
                              <Col md={6} style={{ textAlign: "center", marginTop: "10px" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  style={{width: "135px"}}
                                  onClick={e => this.openAuthModal(e, 'update')}
                                >Update</Button>
                              </Col>
                              <Col md={6} style={{ textAlign: "center", marginTop: "10px" }}>
                                <Button
                                  bsStyle="info"
                                  fill
                                  type="submit"
                                  style={{width: "135px"}}
                                  onClick={e => this.openAuthModal(e, 'reset')}
                                >Factory Default</Button>
                              </Col>
                            </Row>
                          </Panel.Body>
                        </Panel>
                        <div className="clearfix" />
                      </Form>
                    }
                  />
                </Col>
              </Row>
            </Panel.Body>
          </Panel>
        </Grid>
        <Modal
          bsSize="small"
          aria-labelledby='authorize-action-modal'
          show={this.state.showAuthModal}
          onHide={this.closeAuthModal}
        >
          <Modal.Header closeButton>
            <Modal.Title id="authorize-action-modal">Authenticate</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <FormGroup>
                <ControlLabel>Password</ControlLabel>
                <FormControl
                  placeholder="Password"
                  type="password"
                  name="password"
                  onChange={this.handleChange}
                  onKeyDown={this.onKeyPress}
                />
              </FormGroup>
              {this.state.authError}
              <Button bsStyle="info" fill onClick={this.handleServerAction} bsStyle="info">Authenticate</Button>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeAuthModal}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          bsSize="medium"
          aria-labelledby='authorize-action-modal'
          show={this.state.showUpdateModal}
          onHide={this.closeUpdateModal}
        >
          <Modal.Header closeButton>
            <Modal.Title id="authorize-action-modal">Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <FormGroup>
                <Row>
                  <Col md={12} style={{ textAlign: "center" }}>
                    {this.state.updateError ? (
                      <small className="text-danger">
                        Error in updating. Please try again.
                      </small>
                    ): ''}
                  </Col>
                  <Col md={12} style={{ textAlign: "center", marginTop: "10px" }}>
                    <HorizontalFormFileUpload
                      ncols={["col-md-12"]}
                      label="File"
                      onValueChange={this.updateState}
                      statekey="updateFileUpload"
                      type="file"
                      bsClass="form-control"
                      required={true}
                      disabled={false}
                    />
                  </Col>
                </Row>
                <Row className="show-grid">
                  <Col md={12} style={{ textAlign: "center", marginTop: "10px" }}>
                    <Progress percentage={this.state.uploadPercentage} hidden={!this.state.showProgress} />
                  </Col>
                </Row>
                <Row className="show-grid">
                  <Col md={12} style={{ textAlign: "center", marginTop: "10px" }}>
                    <Button
                      bsStyle="info"
                      fill
                      type="submit"
                      disabled={this.state.disableUpload}
                      onClick={e => this.onUpdate(e)}
                    >Upload</Button>
                  </Col>
                </Row>
              </FormGroup>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeUpdateModal}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let backupFiles = state.streamList.backupFiles || [];
  return {
    error: state.error,
    nics: state.sysConfig.nics,
    about: state.sysConfig.about,
    password: state.password,
    newPassword: state.newPassword,
    backupFiles: backupFiles,
    enableSSH: state.sysConfig.enableSSH,
    showUpdateModal: state.sysConfig.showUpdateModal
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    streamActions: bindActionCreators(streamActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SysConfig);
